import { UserType } from '../Actions/ActionType'

const initialState = {
  userInfo: false,
  language: 'en',
  translations: {},
  companyInfo: false
}

const getUser = (state, action) => {
  const newState = {}
  const { entityType } = action.payload
  let access = []

  if (entityType === 'Business') {
    access = action.payload.roleData?.access || []
  }

  if (entityType === 'Patient') {
    access = action.payload.businessData?.configurations?.patientScreenAccess || []
  }

  if (action.payload.company && action.payload.userType === 'Admin') {
    access.push('adminAccess')
  } else if (action.payload.userType === 'Admin') {
    access.push('add-company')
  }

  Object.assign(newState, state, {
    userInfo: action.payload,
    language: action.payload.language
  })

  return newState
}

const setData = (state, action) => {
  const newState = {}
  Object.assign(newState, state, action.payload)

  return newState
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UserType.GET_USER: {
      return getUser(state, action)
    }

    case UserType.SET_USER_REDUCER: {
      return setData(state, action)
    }

    default: {
      return state
    }
  }
}
